<app-menu>
    <div class="cwo-shell min-h-full bg-[var(--cwo-bg)] text-[var(--cwo-text-main)]" [attr.data-theme]="themeMode">
        <section class="relative overflow-hidden rounded-[28px] border border-[var(--cwo-border)] bg-[var(--cwo-surface)] shadow-[0_24px_70px_rgba(2,6,23,0.18)]">
            <div class="pointer-events-none absolute -left-20 top-0 h-48 w-48 rounded-full bg-sky-400/10 blur-3xl"></div>
            <div class="pointer-events-none absolute right-0 top-0 h-56 w-56 rounded-full bg-emerald-400/10 blur-3xl"></div>
            <div class="pointer-events-none absolute inset-0 bg-[linear-gradient(135deg,rgba(255,255,255,0.06),transparent_35%)]"></div>

            <div class="relative flex flex-col gap-6 px-5 py-5 sm:px-6 lg:px-8 xl:flex-row xl:items-start xl:justify-between">
                <!-- MAP PART -->
                <div class="min-w-0 flex-1 space-y-5">
                    <div class="space-y-1 flex flex-row lg:justify-between items-center">
                        <h1 class="text-3xl font-black tracking-[-0.04em] text-[var(--cwo-text-main)] sm:text-4xl">Zone Manager</h1>
                        <a class="bg-blue-500 text-white px-4 py-2 rounded-2xl border-none no-underline text-inherit" href="mailto:jennifer@ulaap.com?subject=Zone%20Boundary%20Change%20Request&cc=allan@ulaap.com">Request a zone area change</a>
                    </div>
                    <!-- HAVE MAP TO SHOW -->
                    <ng-container *ngIf="isMapReady; else noMap">
                        <div #mapBox style="height: 400px;">
                        </div>
                    </ng-container>
                    <!-- NO MAP TO SHOW -->
                    <ng-template #noMap>
                        <div class="rounded-2xl border border-dashed border-[var(--cwo-border)] bg-[var(--cwo-surface-2)] px-4 py-4 text-sm font-semibold text-[var(--cwo-text-main)] shadow-sm">
                            Please select a contact and country to view zones.
                        </div>
                    </ng-template>
                </div>
                <!-- SELECTION AREA -->
                <div class="flex w-full flex-col gap-3 xl:w-[340px] xl:min-w-[340px]">
                    <div class="rounded-3xl border border-[var(--cwo-border)] bg-[var(--cwo-surface-2)]/90 p-4 shadow-sm backdrop-blur">
                        <label class="mt-4 block text-[11px] font-semibold uppercase tracking-[0.18em] text-[var(--cwo-text-secondary)]" for="carrier-scope-select">
                            Load rate zones for...
                        </label>

                        <select
                            id="contact-scope-select"
                            class="cwo-scope-select mt-2 w-full rounded-2xl border px-4 py-3 text-sm font-semibold"
                            [ngModel]="selectedContact"
                            [disabled]="contactOptionsLoading"
                            (ngModelChange)="onContactSelectionChange($event)"
                        >
                            <option value="">Select a contact...</option>
                            <option *ngFor="let contact of contactOptions" [value]="contact.contact_uuid">
                            {{ contact.contact_organization }}
                            </option>
                        </select>

                        <select
                            id="country-scope-select"
                            class="cwo-scope-select mt-2 w-full rounded-2xl border px-4 py-3 text-sm font-semibold"
                            [value]="selectedCountry"
                            [disabled]="contactOptionsLoading"
                            (change)="onCountrySelectionChange($any($event.target).value)"
                        >
                            <option value="">Select a country...</option>
                            <option *ngFor="let country of countryOptions" [value]="country">
                            {{ country }}
                            </option>
                        </select>

                        <select
                            id="zone-scope-select"
                            class="cwo-scope-select mt-2 w-full rounded-2xl border px-4 py-3 text-sm font-semibold"
                            [value]="selectedZone"
                            [disabled]="contactOptionsLoading"
                            (change)="onZoneSelectionChange($any($event.target).value)"
                        >
                            <option value="">Select a zone...</option>
                            <option *ngFor="let zone of zoneOptions" [value]="zone.zone_uuid">
                            {{ zone.zone_name }}
                            </option>
                        </select>

                        <p *ngIf="contactOptionsError" class="mt-2 text-xs font-medium text-rose-400">
                            {{ contactOptionsError }}
                        </p>

                        <p *ngIf="!contactOptionsError" class="mt-2 text-xs text-[var(--cwo-text-secondary)]">
                            {{ contactOptionsLoading ? 'Loading contact\'s rate zones...' : '' }}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</app-menu>